import dynamic from "next/dynamic";
import React, { Suspense } from "react";

const Desktop = dynamic(() => import("./Desktop"), {
  suspense: true,
});
const Mobile = dynamic(() => import("./Mobile"), {
  suspense: true,
});

const Navbar = () => {
  return (
    <header className="bg-primary text-white sticky top-0 z-50">
      <div className="lg:block hidden">
        <Suspense fallback={<></>}>
          <Desktop />
        </Suspense>
      </div>
      <div className="lg:hidden block">
        <Suspense fallback={<></>}>
          <Mobile />
        </Suspense>
      </div>
    </header>
  );
};

export default Navbar;
